import React from "react";
import {Route, Switch} from "react-router-dom";
import Routes from "../constants/Routes";
import DefaultHome from "./DefaultHome";
import LoginView from '../auth/LoginView';
import SignUpView from '../auth/SignUpView';
import ForgotPasswordView from '../auth/ForgotPasswordView';
import Home from './../home/Home';
import Welcome from './../onboarding/Welcome';
import VerifyEmailView from './../auth/VerifyEmailView';
import Strings from "../lang/Strings";
import VerifyGames from "../views/VerifyGames";
import Profile from "../home/Profile";
import TermsAndConditions from "../onboarding/TermsAndConditions";

export default class ApplicationLoader extends React.Component {

    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        document.title = Strings.APP_NAME
    }

    render() {
        return (
            <Switch>
                <Route path={Routes.TERMS_AND_CONDITIONS} component={TermsAndConditions}/>
                <Route path={Routes.SIGN_UP} component={SignUpView}/>
                <Route path={Routes.VERIFY_EMAIL} component={VerifyEmailView}/>
                <Route path={Routes.LOGIN} component={LoginView}/>
                <Route path={Routes.PASSWORD_RECOVERY} component={ForgotPasswordView}/>
                <Route path={Routes.VERIFY_RESULTS} component={VerifyGames}/>
                <Route path={Routes.HOME} component={Home}/>
                <Route path={Routes.WELCOME} component={Welcome}/>
                <Route exact path={Routes.DEFAULT} component={DefaultHome}/>
                <Route component={DefaultHome}/>
            </Switch>
        );
    }
}